const config = {
  apiGateway: {
    URL: "https://foqrs5072c.execute-api.ca-central-1.amazonaws.com/v1/",
    AUTH: "https://pnlve1c098.execute-api.ca-central-1.amazonaws.com/v1/",
    REGION: "ca-central-1"
  },
  defaultLanguage: "en",
  sso_enabled: true,
  sso_config: {
            auth_url: "slf-prod.auth.ca-central-1.amazoncognito.com",
            identity_provider: "SLF-PROD-AD",
            scope: "openid+aws.cognito.signin.user.admin",
            grant_type: "authorization_code",
            client_id: "2chm2u42g10f0nmpsdk0fsdrt2",
            redirect_uri: "https://foureyes.sunlife.com/authorize",
        },
  dast_config: {enabled: false},
  canadaPostApiKey: "YD28-JP31-JP55-UR97",
  fef_ui_version: "2.0.62.1-tier2"
}

var siteConfig = {
  title: "Sun Life",
  fourlyticsId: false,
  fourlyticsScreenRecording: false
};

var componentConfig = {
  
};

export {config, siteConfig, componentConfig}
